<rs-top-bar-menu
  [application]="topBarApplicationCode"
  [menuItems]="menuItems()"
  (onLogout)="onLogout()"
/>

<rs-loader />

<router-outlet />

<rs-footer />